export default "__VITE_ASSET__CNJI$zIr__"